export const paymentService = {
    hasApplePayEnvironmentSupport() {
        if (typeof window === 'undefined' || typeof navigator === 'undefined') {
            return false
        }

        if (!window.ApplePaySession) {
            return false
        }

        const userAgent = String(navigator.userAgent || '').toLowerCase()
        const platform = String(navigator.platform || '')
        const vendor = String(navigator.vendor || '').toLowerCase()
        const maxTouchPoints = Number(navigator.maxTouchPoints || 0)

        const isAppleMobileDevice = /iphone|ipad|ipod/.test(userAgent)
        const isTouchMac = platform === 'MacIntel' && maxTouchPoints > 1
        const isSafari =
            /safari/.test(userAgent) &&
            !/chrome|crios|fxios|edg|opr|opera|android/.test(userAgent)

        return isAppleMobileDevice || isTouchMac || (vendor.includes('apple') && isSafari)
    },

    applyEarlyAvailabilityHints(methods) {
        const applePayEnvironmentSupported = this.hasApplePayEnvironmentSupport()

        return methods.map((method) => {
            if (
                ['apple_pay', 'web_apple_pay', 'applepay'].includes(method.method) &&
                !applePayEnvironmentSupported
            ) {
                return {
                    ...method,
                    isAvailable: false,
                    isAvailabilityChecking: false,
                    isAvailabilityResolved: true,
                }
            }

            return method
        })
    },

    isWalletMethod(method) {
        return [
            'apple_pay',
            'google_pay',
            'web_apple_pay',
            'web_google_pay',
            'applepay'
        ].includes(method)
    },

    isImmediatelyAvailableMethod(method) {
        return [
            'card',
            'web_card',
            'creditcard',
            'oneclick',
            'thawani'
        ].includes(method)
    },

    // 获取所有网关配置的Map
    getGatewayConfig (paymentConfigList) {
        const configMap = {}
        paymentConfigList.forEach(config => {
            const key = config.name // 使用name作为key
            configMap[key] = {
                gatewayId: config.gateway_id || 0,
                ...config.config,
                paymentMethodTypes: config.payment_method_types || []
            }
        })
        return configMap
    },

    // 生成支付方法列表
    generatePaymentMethods (paymentConfigList) {
        const supportedMethods = [
            { gateway: 'stripe', method: 'apple_pay' },
            { gateway: 'stripe', method: 'google_pay' },
            { gateway: 'fortis', method: 'web_apple_pay' },
            { gateway: 'fortis', method: 'web_google_pay' },
            { gateway: 'moyasar', method: 'applepay' },
            { gateway: 'stripe', method: 'card' },
            { gateway: 'fortis', method: 'web_card' },
            { gateway: 'moyasar', method: 'creditcard' },
            { gateway: 'oneclick', method: 'oneclick' },
            { gateway: 'thawani', method: 'thawani' }
        ]

        const hasMoyasarGateway = paymentConfigList.some(
            config => config.name === 'moyasar'
        )

        return supportedMethods
            .filter(method => {
                const gatewayConfig = paymentConfigList.find(
                    config => config.name === method.gateway
                )
                const paymentMethodTypes = gatewayConfig?.payment_method_types

                if (
                    method.gateway === 'moyasar' &&
                    hasMoyasarGateway &&
                    paymentMethodTypes == null
                ) {
                    return method.method === 'creditcard' || method.method === 'applepay'
                }

                return (
                    gatewayConfig &&
                    (
                        Array.isArray(paymentMethodTypes)
                            ? paymentMethodTypes.includes(method.method)
                            : paymentMethodTypes == null
                                ? method.method === method.gateway
                                : false
                    )
                )
            })
            .map(method => ({
                gateway: method.gateway,
                method: method.method,
                isAvailable: this.isImmediatelyAvailableMethod(method.method),
                isAvailabilityChecking: this.isWalletMethod(method.method),
                isAvailabilityResolved: this.isImmediatelyAvailableMethod(method.method)
            }))
    },

    // 统一 after-payment 事件载荷
    makeAfterPaymentPayload ({ provider, method, ev, paymentToken, isRepay = false, meta = {} }) {
        return {
            provider,
            method,
            ev,
            paymentToken,
            isRepay,
            ...meta
        }
    }
}
